import React from 'react';
import PropTypes from 'prop-types';

import Multiplechoice from './Multiplechoice';
import Feedback from './Feedback';
import FreeResponse from './FreeResponse';
import RsvpToEvent from './RSVP';
import ChangeEmail from './ChangeEmail';
import InviteSpouse from './InviteSpouse';

import {
  MULTIPLE_CHOICE,
  FEEDBACK,
  FREE_RESPONSE,
  RSVP,
  CHANGE_EMAIL,
  INVITE_SPOUSE,
} from '../../../utils/constants';

const SurveyItem = ({ option }) => {
  switch (option) {
    case MULTIPLE_CHOICE:
      return <Multiplechoice option={option} />
    case FEEDBACK:
      return <Feedback />
    case FREE_RESPONSE:
      return <FreeResponse />
    case RSVP:
      return <RsvpToEvent />
    case CHANGE_EMAIL:
      return <ChangeEmail option={option} />
    case INVITE_SPOUSE:
      return <InviteSpouse />
  }
};

export default SurveyItem;

SurveyItem.propTypes = {
  option: PropTypes.string,
};
